import React, { useMemo, ReactElement } from 'react';
import FlexContainer from '../flex-container/flex-container.component';
import FieldSelect from '../field-select/field-select.component';
import MenuItemList from '../menu-item-list/menu-item-list.component';
import useStylesChartGanttZoomBlock from './chart-gantt-zoom-block.styles';

const ChartGanttZoomBlock: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    zoomValue,
    zoomItemList,
    onZoomChange,
  } = props;

  const { classes } = useStylesChartGanttZoomBlock();

  const menuItemZoomItemList: ReactElement[] = useMemo((): ReactElement[] => MenuItemList({
    optionItemValueKey: 'name',
    optionList: zoomItemList,
    selectedValue: zoomValue,
  }), [zoomValue, zoomItemList]);

  return (
    <FlexContainer isInline className={classes.chartGanttZoomBlock}>
      <FlexContainer className={classes.chartGanttZoomBlockLabel}>
        Zoom
      </FlexContainer>
      <FlexContainer className={classes.chartGanttZoomBlockFieldSelect}>
        <FieldSelect
          isPlain
          isBordered
          value={zoomValue}
          onChange={(event: EventSelectChange, value: string): void => {
            if (onZoomChange) {
              onZoomChange(value);
            }
          }}
        >
          {menuItemZoomItemList}
        </FieldSelect>
      </FlexContainer>
    </FlexContainer>
  );
});

export default ChartGanttZoomBlock;
